export const AER_LABELS = {
  AVG: 'Avg. AER',
  CURRENT: 'Current AER',
};
